module.exports = __webpack_public_path__ + "static/img/7.fb655c96.gif";